import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GlobalFaStylePipe } from './pipes/global-fa-style.pipe';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StringToObjectPipe } from './pipes/string-to-object.pipe';
import { GetImageFromStatePipe } from './pipes/get-image-from-state.pipe';
import { GetVideoFromStatePipe } from './pipes/get-video-from-state.pipe';
import { GetAudioFromStatePipe } from './pipes/get-audio-from-state.pipe';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  declarations: [
    GlobalFaStylePipe,
    StringToObjectPipe,
    GetImageFromStatePipe,
    GetVideoFromStatePipe,
    GetAudioFromStatePipe,
   ],
  exports: [
    StringToObjectPipe,
    GlobalFaStylePipe,
    GetImageFromStatePipe,
    GetVideoFromStatePipe,
    GetAudioFromStatePipe,
    FontAwesomeModule
  ]
})
export class SharedUiThemingModule {

}
